import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  defaultUsersInfo,
  DataInfoType,
  FilterUpdate,
  UsersDataInfo,
  CardsDataInfo,
  defaultCardsInfo,
  SessionsDataInfo,
  defaultSessionsInfo,
  ExamineesDataInfo,
  defaultExamineesInfo,
  AssessmentDataInfo,
  defaultAssessmentInfo,
  SampleAssessmentDataInfo,
  defaultSampleAssessmentInfo,
} from './filterSlice.types';
import _ from 'lodash';

export interface FiltersState {
  userInfo: UsersDataInfo;
  examinersInfo: UsersDataInfo;
  cardsInfo: CardsDataInfo;
  sessionsInfo: SessionsDataInfo;
  examineesInfo: ExamineesDataInfo;
  assessmentTrainingInfo: AssessmentDataInfo;
  assessmentQualificationInfo: AssessmentDataInfo;
  assessmentScoringInfo: AssessmentDataInfo;
  assessmentControlInfo: AssessmentDataInfo;
  sampleAssessmentInfo: SampleAssessmentDataInfo;
}

const initialState: FiltersState = {
  userInfo: { ...defaultUsersInfo },
  examinersInfo: { ...defaultUsersInfo },
  cardsInfo: { ...defaultCardsInfo },
  sessionsInfo: { ...defaultSessionsInfo },
  examineesInfo: { ...defaultExamineesInfo },
  assessmentTrainingInfo: { ...defaultAssessmentInfo },
  assessmentQualificationInfo: { ...defaultAssessmentInfo },
  assessmentScoringInfo: { ...defaultAssessmentInfo },
  assessmentControlInfo: { ...defaultAssessmentInfo },
  sampleAssessmentInfo: { ...defaultSampleAssessmentInfo },
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    resetFilter: (state, action: PayloadAction<DataInfoType>) => {
      state[action.payload].filterData = initialState[action.payload].filterData;
    },
    updateFilter: (state, action: PayloadAction<FilterUpdate>) => {
      // console.log(' updateFilter', action.payload.filterType, action.payload);
      state[action.payload.filterType].filterData = _.mergeWith(
        {},
        state[action.payload.filterType].filterData,
        action.payload.newValues,
        (_a, b) => (_.isArray(b) ? b : undefined),
      );
    },
  },
});

export const filtersActions = filtersSlice.actions;
export default filtersSlice;
